import { Suspense, lazy, useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import "../styles/App.scss";
import { Route, Switch } from "react-router-dom";
import history from "../helpers/history";
import { ToastContainer } from "react-toastify";
import { routesCommon } from "../constants";
import { LoaderPage } from "../components/LoaderPage";
import { Page404 } from "../components/404";
import { FinalNotePdfPersistHost } from "../components/DoctorFlow/finalNotePdfPersist";

const LoginForms = lazy(() =>
  import("../components/LoginForms").then((m) => ({ default: m.LoginForms })),
);
const CreateRequest = lazy(() =>
  import("./CreateRequest.jsx").then((m) => ({ default: m.CreateRequest })),
);
const ProtectedApp = lazy(() =>
  import("./ProtectedApp.jsx").then((m) => ({ default: m.ProtectedApp })),
);

export const App = ({ location }) => {
  useEffect(() => {
    window.localStorage.setItem("chats", "{}");
    window.localStorage.removeItem("requests");
    window.localStorage.removeItem("refresh_extra_url");
    window.localStorage.removeItem("listPatients");
    window.localStorage.removeItem("loadingTemp");
    if (location.pathname === "/") {
      window.open(routesCommon.landing);
    } else {
      history.push(location.pathname);
    }
  }, []);

  return (
    <Route path="/">
      <Switch>
        <Route
          path={`${routesCommon.login_form}/:user`}
          render={(params) => (
            <Suspense fallback={<LoaderPage />}>
              <LoginForms params={params} />
            </Suspense>
          )}
        />
        <Route
          path={`${routesCommon.create_request}/:typeUuid`}
          render={() => (
            <Suspense fallback={<LoaderPage />}>
              <CreateRequest />
            </Suspense>
          )}
        />
        <Route
          path={[routesCommon.admin, routesCommon.doctor, routesCommon.patient]}
          render={({ match: { url } }) => {
            return (
              <Suspense fallback={<LoaderPage />}>
                <ProtectedApp path={`${url}`} />
              </Suspense>
            );
          }}
        />
        <Route component={Page404} />
        <ToastContainer
          position="top-right"
          autoClose={false}
          newestOnTop={false}
          closeOnClick
          containerId="test"
          rtl={false}
          pauseOnVisibilityChange
          draggable
        />
      </Switch>
      <FinalNotePdfPersistHost pathname={location.pathname} />
      <LoaderPage show={false} global />
    </Route>
  );
};
